<app-topnav [pageName]="pageName"></app-topnav>

<div class="h-30"></div>
<div class="container" [hidden]="!hideReviewPanel">
  <div class="content" role="main">
    <div class="facility-heading">Edit Material</div>
    <form #rpform="ngForm">
      <div class="designatedFacilityForm">

        <div class="form-fields">
          <mat-form-field appearance="outline" floatLabel="always">
            <mat-label>Material Name</mat-label>
            <input matInput class="form-control-textbox" [(ngModel)]="material.materialName" name="name" />
          </mat-form-field>
          @if (isSubmitted && (material.materialName === null || material.materialName === undefined || material.materialName === '')) {
            <mat-error class="validation-error">Material Name is required</mat-error>
          }
        </div>
        <div class="mb-10"></div>
        <div class="form-fields">
          <mat-form-field appearance="outline" floatLabel="always">
            <mat-label>Type</mat-label>
            <mat-select placeholder="Select Type" name="materialType" [(ngModel)]="material.materialType" [disabled]="!material.isMaterialTypeEditable" required>
              @for (mt of materialTypes; track mt) {
                <mat-option [value]="mt.id">{{
                mt.type}}</mat-option>
              }
            </mat-select>
          </mat-form-field>
          @if (isSubmitted && material.materialType == 0) {
            <mat-error class="validation-error">Material Type is required</mat-error>
          }
        </div>
        <div class="mb-10"></div>
        <div class="form-fields">
          <mat-form-field appearance="outline" floatLabel="always">
            <mat-label>Language</mat-label>
            <mat-select placeholder="Select Type" name="materiallanguage" [(ngModel)]="material.language" [disabled]="!material.isLanguageEditable" required>
              @for (ml of materialLanguage; track ml) {
                <mat-option [value]="ml.id">{{
                ml.description}}</mat-option>
              }
            </mat-select>

          </mat-form-field>
          @if (isSubmitted && material.language ==0) {
            <mat-error class="validation-error">Language is required</mat-error>
          }
        </div>
        <div class="mb-10"></div>
        <div class="form-fields">
          <mat-form-field>
            <mat-label>Tags</mat-label>
            <mat-select placeholder="Select" name="materialtags" multiple [(value)]="selectedTags" [(ngModel)]="selectedTags">
              <mat-select-trigger>
                <div class="selected-pills">
                  @for (tag of selectedTags; track tag) {
                    <span class="pill">
                      {{ getTagName(tag).replace(',','') }}
                    </span>
                  }
                </div>
              </mat-select-trigger>
              @for (tag of tags; track tag) {
                <mat-option [value]="tag.id">
                  {{ tag.tagName }}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>

        </div>
        <div class="mb-10"></div>
        <div class="material-upload-section">
          <div class="material-upload-title">Add Material</div>
          <ngx-dropzone (change)="onSelect($event)" [multiple]="false" [disabled]="isUploading || isSaving" [hidden]="isUploading || showFileDescDiv">
            <ngx-dropzone-label>
              {{selectedFileName}}
            </ngx-dropzone-label>
          </ngx-dropzone>

          @if (isUploading) {
            <div class="upload-progress-card" [class.upload-complete]="isUploadComplete">
              <div class="upload-progress-header">
                <span class="upload-file-name">{{ selectedFileName }}</span>
                <span class="upload-percent">{{ uploadProgress }}%</span>
              </div>
              <div class="upload-progress-track">
                <div class="upload-progress-fill" [style.width.%]="uploadProgress"></div>
              </div>
              <p class="upload-progress-label">{{ isUploadComplete ? 'Uploaded successfully!' : 'Uploading material file...' }}</p>
            </div>
          }

          @if (!isUploading && showFileDescDiv) {
            <div class="uploaded-file-card">
              <div class="uploaded-file-icon" aria-hidden="true">
                <svg viewBox="0 0 24 24" width="22" height="22" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8l-6-6z" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"/>
                  <path d="M14 2v6h6" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"/>
                </svg>
              </div>
              <div class="uploaded-file-info">
                <div class="uploaded-file-name" [title]="material.materialFileName">{{ material.materialFileName }}</div>
                <div class="uploaded-file-meta">
                  <span class="upload-success-badge">
                    <svg viewBox="0 0 16 16" width="12" height="12" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                      <path d="M3.5 8.5l3 3 6-6" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                    Uploaded
                  </span>
                </div>
              </div>
              <div class="uploaded-file-actions">
                <button type="button" class="file-action-btn" (click)="downloadFile()" title="Download">
                  <img src="assets/filelinkicon.svg" class="materialdownloadfile" alt="Download">
                </button>
                <button type="button" class="file-action-btn" [hidden]="!material.showFileUploader" (click)="removeMaterialFile()" title="Remove">
                  <img src="assets/trash.svg" class="materialdeletefile" alt="Remove">
                </button>
              </div>
            </div>
          }

        </div>
        <div class="mb-10"></div>
        @if (isSubmitted && material.materialFileId ==0) {
          <mat-error>Material File is required</mat-error>
        }
        <div class="mb-10"></div>
        <div>
          Status
          <div class="toggle">
            @for (ms of materialStatus; track ms) {
              <div class="switch-div">
                <input  type="radio" [value]="ms.key" [name]="ms.value" [id]="ms.key" [className]="ms.value.toLowerCase()" (change)="statusChange()" [(ngModel)]="material.status" />
                <label for="{{ms.key}}">{{ms.value}}</label>
              </div>
            }
          </div>
          @if (isSubmitted && material.status ==0) {
            <mat-error class="validation-error">Status is required</mat-error>
          }
        </div>

        <div class="mb-10"></div>

        <div id="replacementdiv" [hidden]="!showReplacementDiv">
          <fieldset>
            <label id="intake-form-meeting-attendee-label">
              Select replacement for retired material, or choose to retire without a replacement
            </label>
            <div class="form-section-validator-controls w-10p0">
              <mat-radio-group name="radMeetingAttendeesGroupsection1" aria-labelledby="intake-form-meeting-attendee-label" [(ngModel)]="replacementRadioValue"
                (change)="replacementRadioChange()">
                <!-- #meetingAttendees="ngModel" required -->
                <mat-radio-button name="radioMeetingAttendee1section1" class="intake-form-radio-button display-vertical"
                  value="1">
                  Retire with Replacement
                </mat-radio-button>
                <mat-radio-button name="radioMeetingAttendee2section1" class="intake-form-radio-button" value="2" checked>
                  Retire without Replacement
                </mat-radio-button>
              </mat-radio-group>
            </div>
          </fieldset>
        </div>
        <div class="h-30"></div>
        <div [hidden]="!showReplacementFileSelector">
          <mat-form-field appearance="outline" floatLabel="always" class="w-10p0">
            <mat-label>Replacement Material</mat-label>
            <input type="text" placeholder="Select Replacement Material" matInput [matAutocomplete]="auto"
              name="replacementMaterial" [(ngModel)]="selectedMaterial" (ngModelChange)="updateMaterialFiltering()"
              #username="ngModel" ng-MinLength="1">
              <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn">
                @for (material of filteredOptions | async; track material) {
                  <mat-option [value]="material">
                    {{material.materialName}}
                  </mat-option>
                }
              </mat-autocomplete>
            </mat-form-field>
          </div>

          <div class="form-buttons">
            <input type="submit" class="submit-form-button" (click)="onSubmit(rpform)" value="Submit" [disabled]="isUploading || isSaving"/>
            <a class="submit-form-button cancel-button" (click)="cancel()">Cancel</a>
          </div>

        </div>
      </form>
    </div>
  </div>

  <!--review section of add tag-->
  @if (modalOpen | async) {
    <app-modal [title]="modalTitle" [content]="modalContent" [okButtonValue]="modalOkButtonValue"
    [cancelButtonValue]="modalCancelButtonValue" [okButtonText]="modalOkButtonText" [cancelButtonText]="modalCancelButtonText"></app-modal>
  }

  <app-footer [bbapp]="true"></app-footer>
